module.exports = {
  CHUNK_LOADING_GLOBAL: '__COMMON_LOADED_CHUNKS__',
};
